// the app store
// index ca sa lege reducers si actions

// Holds the current application state inside
// Allows access to the current state via store.getState();
// Allows state to be updated via store.dispatch(action);
// Registers listener callbacks via store.subscribe(listener);
// Handles unregistering of listeners via the unsubscribe function returned by store.subscribe(listener).

import { configureStore } from '@reduxjs/toolkit'
import authReducer from './reducers/auth'

const Store = configureStore({
    reducer: {
        auth: authReducer
    }
});

export default Store;



// replace class cu function
//  handles -> ()=>

// const ex [state, setState] = useState('exemplu')

// setState = val noua; -> call syncron
// setState = (prev) => new State  -> cand setezi state din call asyncron

